// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar CSS */
.sidebar {
    width: 250px; /* Default width for desktop */
    flex-shrink: 0;
    background-color: #2c3e50; /* Darker background color */
    height: 100vh;
    color: #ecf0f1;
    transition: width 0.3s;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);
  }
  
  .sidebar .logo {
    text-align: center;
    padding: 20px;
    background-color: #34495e; /* Slightly different dark color for the logo area */
  }
  
  .logo img {
    max-width: 100%;
    height: auto;
  }
  
  .sidebar-item {
    padding: 15px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: background-color 0.15s;
    border-radius: 5px;
    cursor: pointer;
    font-size: 15px;
    color: #ecf0f1; /* Light color for text */
  }
  
  .sidebar-item:hover {
    background-color: rgba(255, 255, 255, 0.1);
    color: #ecf0f1; /* Keep text color same */
  }
  
  .sidebar-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  
  .sidebar-content {
    padding-left: 10px;
  }
  
  .sidebar-item.plain {
    text-decoration: none;
    color: inherit; /* Inherit color from parent */
    display: flex;
    align-items: center;
  }
  
  /* Hamburger Icon for Mobile */
  .hamburger-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
    display: none; /* Hidden by default */
  }
  
  .hamburger-icon img {
    width: 35px; /* Adjust width as needed */
    height: 35px; /* Adjust height as needed */
  }
  
  /* Media query for mobile devices */
  @media screen and (max-width: 768px) {
    .sidebar {
      width: 200px; /* Adjusted width for mobile */
      position: fixed;
      left: 0;
      top: 0;
      bottom: 0;
      z-index: 1000;
      transform: translateX(-100%);
      transition: transform 0.3s ease;
    }
  
    .sidebar.open {
      transform: translateX(0);
    }
  
    .hamburger-icon {
      display: block;
    }
  
    .sidebar-item {
      padding: 10px 15px; /* Adjusted padding for mobile */
    }
  }
  

  `, "",{"version":3,"sources":["webpack://./src/components/sidebar/Sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,YAAY,EAAE,8BAA8B;IAC5C,cAAc;IACd,yBAAyB,EAAE,4BAA4B;IACvD,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,yBAAyB,EAAE,oDAAoD;EACjF;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,0CAA0C;IAC1C,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,cAAc,EAAE,8BAA8B;IAC9C,aAAa;IACb,mBAAmB;EACrB;;EAEA,8BAA8B;EAC9B;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,aAAa,EAAE,sBAAsB;EACvC;;EAEA;IACE,WAAW,EAAE,2BAA2B;IACxC,YAAY,EAAE,4BAA4B;EAC5C;;EAEA,mCAAmC;EACnC;IACE;MACE,YAAY,EAAE,8BAA8B;MAC5C,eAAe;MACf,OAAO;MACP,MAAM;MACN,SAAS;MACT,aAAa;MACb,4BAA4B;MAC5B,+BAA+B;IACjC;;IAEA;MACE,wBAAwB;IAC1B;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,kBAAkB,EAAE,gCAAgC;IACtD;EACF","sourcesContent":["/* Sidebar CSS */\r\n.sidebar {\r\n    width: 250px; /* Default width for desktop */\r\n    flex-shrink: 0;\r\n    background-color: #2c3e50; /* Darker background color */\r\n    height: 100vh;\r\n    color: #ecf0f1;\r\n    transition: width 0.3s;\r\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.5);\r\n  }\r\n  \r\n  .sidebar .logo {\r\n    text-align: center;\r\n    padding: 20px;\r\n    background-color: #34495e; /* Slightly different dark color for the logo area */\r\n  }\r\n  \r\n  .logo img {\r\n    max-width: 100%;\r\n    height: auto;\r\n  }\r\n  \r\n  .sidebar-item {\r\n    padding: 15px 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    transition: background-color 0.15s;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    color: #ecf0f1; /* Light color for text */\r\n  }\r\n  \r\n  .sidebar-item:hover {\r\n    background-color: rgba(255, 255, 255, 0.1);\r\n    color: #ecf0f1; /* Keep text color same */\r\n  }\r\n  \r\n  .sidebar-title {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n  }\r\n  \r\n  .sidebar-content {\r\n    padding-left: 10px;\r\n  }\r\n  \r\n  .sidebar-item.plain {\r\n    text-decoration: none;\r\n    color: inherit; /* Inherit color from parent */\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  /* Hamburger Icon for Mobile */\r\n  .hamburger-icon {\r\n    position: absolute;\r\n    top: 20px;\r\n    right: 20px;\r\n    cursor: pointer;\r\n    display: none; /* Hidden by default */\r\n  }\r\n  \r\n  .hamburger-icon img {\r\n    width: 35px; /* Adjust width as needed */\r\n    height: 35px; /* Adjust height as needed */\r\n  }\r\n  \r\n  /* Media query for mobile devices */\r\n  @media screen and (max-width: 768px) {\r\n    .sidebar {\r\n      width: 200px; /* Adjusted width for mobile */\r\n      position: fixed;\r\n      left: 0;\r\n      top: 0;\r\n      bottom: 0;\r\n      z-index: 1000;\r\n      transform: translateX(-100%);\r\n      transition: transform 0.3s ease;\r\n    }\r\n  \r\n    .sidebar.open {\r\n      transform: translateX(0);\r\n    }\r\n  \r\n    .hamburger-icon {\r\n      display: block;\r\n    }\r\n  \r\n    .sidebar-item {\r\n      padding: 10px 15px; /* Adjusted padding for mobile */\r\n    }\r\n  }\r\n  \r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
